import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SchemeHeader } from '../../components/Scheme/SchemeHeader';
import { SchemeFilters } from '../../components/Scheme/SchemeFilters';
import { SchemeTable } from '../../components/Scheme/SchemeTable';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { fetchSchemes, clearSuccessMessage } from '../../store/schemeSlice';
import { exportToCSV } from '../../utils/csvExport';

export const SchemesList: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { schemes, successMessage } = useAppSelector((state) => state.scheme);

  useEffect(() => {
    dispatch(fetchSchemes());
  }, [dispatch]);

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        dispatch(clearSuccessMessage());
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [successMessage, dispatch]);

  const handleExportCSV = () => {
    const headers = ['Scheme ID', 'Scheme Name', 'Type', 'Start Date', 'End Date', 'Status'];
    const rows = schemes.map((s: any) => [
      s.id || s.scheme_id,
      s.scheme_name || s.name || '',
      s.scheme_type || s.type || '',
      s.start_date || s.startDate || '',
      s.end_date || s.endDate || '',
      s.status || 'Active',
    ]);
    exportToCSV('schemes_list', headers, rows);
  };

  return (
    <div className="min-h-screen">
      {/* Toast Banner for Success Notifications */}
      {successMessage && (
        <div className="mb-4 bg-emerald-500 text-white px-4 py-3 rounded-xl shadow-md flex items-center justify-between animate-fadeIn">
          <div className="flex items-center gap-2 text-xs md:text-sm font-semibold">
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
            {successMessage}
          </div>
          <button
            onClick={() => dispatch(clearSuccessMessage())}
            className="text-white/80 hover:text-white font-bold text-sm cursor-pointer"
          >
            ✕
          </button>
        </div>
      )}

      {/* Header */}
      <SchemeHeader
        title="Scheme"
        showBack={true}
        onCreateClick={() => navigate('/scheme/create')}
        onExportCsv={handleExportCSV}
      />

      {/* Filters */}
      <SchemeFilters />

      {/* Schemes List Table */}
      <SchemeTable />
    </div>
  );
};
